<div class="flex flex-col w-full">
    <div class="font-extrabold text-xl py-4">
        Order details
    </div>

    <div class="flex flex-col w-full justify-center items-center">

        <div class="flex flex-col w-full md:w-1/2 py-4">
            <div class="flex flex-row font-extrabold pb-2">
                Type of residence:*
            </div>
            <div *ngIf="!isScreenSmall">
                <mat-radio-group aria-label="Select an option" class="flex flex-row justify-between items-center">
                    <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'FreeStanding'"
                        (change)="residenceType($event)" value="FreeStanding">Freestanding
                    </mat-radio-button>
                    <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Estate'" value="Estate"
                        (change)="residenceType($event)">Estate/Complex</mat-radio-button>
                    <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Plot'" value="Plot"
                        (change)="residenceType($event)">Plot</mat-radio-button>
                    <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Apartment'" value="Apartment"
                        (change)="residenceType($event)">Apartment</mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="isScreenSmall">
                <mat-radio-group aria-label="Select an option" class="flex flex-row justify-between items-center">
                    <div class="flex flex-col">
                        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'FreeStanding'"
                            (change)="residenceType($event)" value="FreeStanding">Freestanding
                        </mat-radio-button>
                        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Estate'" value="Estate"
                            (change)="residenceType($event)">Estate/Complex</mat-radio-button>
                    </div>
                    <div class="flex flex-col">

                        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Plot'" value="Plot"
                            (change)="residenceType($event)">Plot</mat-radio-button>
                        <mat-radio-button [color]="'primary'" [checked]="ResidenceType == 'Apartment'" value="Apartment"
                            (change)="residenceType($event)">Apartment</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>

            <hr class="my-5">

            <div *ngIf="ResidenceType == 'FreeStanding'">
                <form [formGroup]="orderDetailsForm" #orderDetailsNgForm="ngForm">
                    <!-- Estate notes field -->
                    <mat-form-field class="w-full">
                        <mat-label>Notes</mat-label>
                        <textarea id="leadNotes" matInput [formControlName]="'LeadNotes'"
                            placeholder="Freestanding residence notes" (keyup)="isFormValid()"> </textarea>
                    </mat-form-field>
                </form>
            </div>

            <div *ngIf="ResidenceType == 'Estate' || ResidenceType == 'Apartment' ">
                <form [formGroup]="orderDetailsForm" #orderDetailsNgForm="ngForm">

                    <!-- Unit Number field -->
                    <mat-form-field class="w-full">
                        <mat-label>Unit number</mat-label>
                        <input id="unitNumber" matInput [formControlName]="'UnitNumber'" placeholder="Unit number"
                            (keyup)="isFormValid()">
                        <mat-error *ngIf="orderDetailsForm.get('UnitNumber').hasError('required')">
                            Unit Number is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Complex name field -->
                    <mat-form-field class="w-full">
                        <mat-label>Estate/Complex name</mat-label>
                        <input id="complexName" matInput [formControlName]="'ComplexName'"
                            placeholder="Estate/Complex name" (keyup)="isFormValid()">
                        <mat-error *ngIf="orderDetailsForm.get('ComplexName').hasError('required')">
                            Estate/Complex name is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Floor number field -->
                    <mat-form-field class="w-full" *ngIf="ResidenceType == 'Apartment'">
                        <mat-label>Floor number</mat-label>
                        <input id="floorNumber" matInput [formControlName]="'FloorNumber'" placeholder="Floor Number"
                            (keyup)="isFormValid()">
                    </mat-form-field>

                    <!-- Block name field -->
                    <mat-form-field class="w-full" *ngIf="ResidenceType == 'Apartment'">
                        <mat-label>Block name</mat-label>
                        <input id="floorNumber" matInput [formControlName]="'BlockName'" placeholder="Block Name"
                            (keyup)="isFormValid()">
                    </mat-form-field>

                    <!-- Complex street name field -->
                    <mat-form-field class="w-full">
                        <mat-label>Estate/Complex street name</mat-label>
                        <input id="complexStreetName" matInput [formControlName]="'ComplexStreetName'"
                            placeholder="Estate/Complex street name" (keyup)="isFormValid()">
                        <mat-error *ngIf="orderDetailsForm.get('ComplexStreetName').hasError('required')">
                            Estate/Complex Street name is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Sub Complex name field -->
                    <mat-form-field class="w-full">
                        <mat-label>Sub-complex name</mat-label>
                        <input id="subComplexName" matInput [formControlName]="'SubComplexName'"
                            placeholder="Sub-complex name" (keyup)="isFormValid()">
                        <mat-error *ngIf="orderDetailsForm.get('SubComplexName').hasError('required')">
                            Sub-complex name name is required
                        </mat-error>
                    </mat-form-field>
                    <!-- Estate notes field -->
                    <mat-form-field class="w-full">
                        <mat-label>Notes</mat-label>
                        <textarea id="leadNotes" matInput [formControlName]="'LeadNotes'"
                            placeholder="Estate/Complex name" (keyup)="isFormValid()"> </textarea>
                    </mat-form-field>
                </form>
            </div>

            <div *ngIf="ResidenceType == 'Plot'">
                <form [formGroup]="orderDetailsForm" #orderDetailsNgForm="ngForm">

                    <!-- Plot Number field -->
                    <mat-form-field class="w-full">
                        <mat-label>Plot number</mat-label>
                        <input id="plotNumber" matInput [formControlName]="'ErfNumber'" placeholder="Plot number"
                            (keyup)="isFormValid()">
                        <mat-error *ngIf="orderDetailsForm.get('ErfNumber').hasError('required')">
                            Plot Number is required
                        </mat-error>
                    </mat-form-field>

                    <!-- Plot notes field -->
                    <mat-form-field class="w-full">
                        <mat-label>Notes</mat-label>
                        <textarea id="leadNotes" matInput [formControlName]="'LeadNotes'"
                            placeholder="Plot name" (keyup)="isFormValid()"> </textarea>
                    </mat-form-field>
                </form>
            </div>
            <hr *ngIf="ResidenceType !== 'FreeStanding'" class="my-5">
            <div class="flex flex-row w-full justify-start items-center">
                <div>
                    <mat-checkbox [color]="'primary'" [checked]="isSameAsInstallAddress"
                        (change)="matCheckBox($event)"></mat-checkbox>
                </div>
                <div>
                    Same as my installation address
                </div>
            </div>
            <div *ngIf="isSameAsInstallAddress">
                <fuse-card class="flex flex-col p-6 w-full">
                    <div class="flex flex-row pb-4">
                        <div>
                            <mat-icon svgIcon="heroicons_solid:map-pin" style="color: #3f2d79;;"
                                class="mr-4 bg-white rounded-xl bg-opacity-60"></mat-icon>
                        </div>
                        <div class="font-extrabold text-xl">
                            Delivery address
                        </div>
                    </div>

                    <div class="pb-2 flex flex-row">
                        <div class="font-bold text-black w-1/2 md:w-2/3 flex flex-col justify-start px-1">
                            Street number:
                        </div>
                        <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                            {{lead?.StreetNumber}}
                        </div>
                    </div>
                    <div class="pb-2 flex flex-row">
                        <div class="font-bold text-black w-1/2 md:w-2/3 flex flex-col justify-start px-1">
                            Street name:
                        </div>
                        <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                            {{lead?.StreetName}}
                        </div>
                    </div>
                    <div class="pb-2 flex flex-row">
                        <div class="font-bold text-black w-1/2 md:w-2/3 flex flex-col justify-start px-1">
                            Suburb, region and postal code:
                        </div>
                        <div class="text-black w-1/2 md:w-1/3 flex flex-col justify-start px-1">
                            {{lead?.Town}}, {{lead?.Region}}, {{lead?.PostalCode}}
                        </div>
                    </div>
                </fuse-card>
            </div>
            <div *ngIf="!isSameAsInstallAddress">
                <app-delivery-details [isScreenSmall]="isScreenSmall"
                    (confirmDeliveryOrderEvent)="confirmDelivery($event)"></app-delivery-details>
            </div>

        </div>

    </div>
</div>